// extracted by mini-css-extract-plugin
export default {"phoneModalWrapper":"style_phoneModalWrapper__8c7DV","phoneModalContent":"style_phoneModalContent__Hyg8t"};